module.exports = __webpack_public_path__ + "static/media/overgrowth.ea036182.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/overgrowth.jpg
 ** module id = 432
 ** module chunks = 0
 **/